import React, { useEffect, useState, useRef } from 'react';
import { Container } from "react-bootstrap";
import { BfRowForm, BfButtonBlue, Heading, DeactivateButton } from '../../../Styling/styledForm/styledBlueForm'
import styled from 'styled-components';
import { useAuth } from '../../../hooks/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import colorConfig from '../../../colorConfig';
import BislabTermsModal from '../modals/BislabTermsModal';
import { getAhlinCMSbyId } from '../../../reduxStore/HeadlessCMS/headlessCmsActions';
import DeactivateModal from '../modals/DeactivateModal';
import { KredittvurderingRowForm } from '../../../Styling/styledKredittvurdering/styledKvComponents';

const SubText = styled.p`
  margin-bottom: 20px;
  color: ${colorConfig.tabellrad_tekst} !important;
  font-weight: 400;
  font-family: "RM Neue", "sans-serif";    
`;

const ArticleArea = styled.div`
   line-height: 33.6px;
   font-family: "RM Neue", "sans-serif";
   color: #003e60;
   
   p {
      margin-bottom: 0px;
      color: ${colorConfig.tabellrad_tekst} !important;
      font-weight: 400;
      font-family: "RM Neue", "sans-serif";
      font-size: 20px;
   }
`;


const SectionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 10px 10px 0;
`;

const LeftSection = styled.div`
  flex: 2;
  margin-right: 20px;
  font-weight: 400;
`;

const RightSection = styled.div`
  flex: 1;
  margin-left: 20px;
  font-weight: 400;
  margin-bottom: -30px; /* Ikke så sexy */
`;

const Divider = styled.div`
  border-left: 1px solid #888888;
  height: auto;
  min-height: 100px;
  margin-top: 16px;
  padding-right: 20px;
  align-self: stretch; 
`;

const TextButton = styled.div`
  background: none;
  border: none;
  font-weight: 800;
  font-family: "RM Neue", "sans-serif"; 
  color: ${colorConfig.tabellrad_tekst} !important;
  text-decoration: underline;
  cursor: pointer;
  padding-left: 5px;
`;

const InfoAndDeactivate = (props) => {

    const showToasts = true
    const localeMessages = props.localeMessages

    const auth = useAuth()

    const newCaseState = props.newCaseState
    const state = props.state
    const ratingData = props.ratingInfoData
    const termsModal = props.termsModal
    const deactivateModal = props.deactivateModal
    const _dispatch = useDispatch()
    let selectedKreditor = newCaseState.kreditorId;
    const acceptedTermsDate = ratingData.createdDate
    const cmsArticlesState = useSelector(state => state.headlessCMS)
    const articleId = 'bislab_prisinfo'

    const [deactivateValue, setDeactivateValue] = useState(false);
    const isUserAdminOrHigher = auth.role !== 'User'

    const thStyle = {
        border: '1px solid #ddd',
        padding: '8px',
        background: 'white',
        textAlign: 'left',
    };

        const tdStyle = {
        border: '1px solid #ddd',
        background: 'white',
        padding: '8px',
    };

        const tdStyleRight = {
        ...tdStyle,
        textAlign: 'right',
    };

    const PRICE_TIERS = [
        { range: '0-50',      private: '32 kr',               business: '40 kr' },
        { range: '51-200',    private: '22 kr',               business: '30 kr' },
        { range: '201-500',   private: '12 kr',               business: '16 kr' },
        { range: '501-1000',  private: '10 kr',               business: '12 kr' },
        { range: '1001-2500', private: '9 kr',                business: '10 kr' },
        { range: '2501-5000', private: '8 kr',                business: '8 kr' },
        { range: '>5000',     private: 'Tilpasset ordning',   business: 'Tilpasset ordning' },
    ];

    function CreditEvaluationPriceList() {
        return (
            <div style={{ overflowX: 'auto', margin: '1rem 0 2rem 0' }}>
            {/* <h2>Prisliste kredittvurdering</h2> */}
            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                <tr>
                    <th colSpan={2} style={thStyle}>Privat</th>
                    <th colSpan={2} style={thStyle}>Næring</th>
                </tr>
                <tr>
                    <th style={thStyle}>Antall pr mnd</th>
                    <th style={thStyle}>Pris (NOK)</th>
                    <th style={thStyle}>Antall pr mnd</th>
                    <th style={thStyle}>Pris (NOK)</th>
                </tr>
                </thead>
                <tbody>
                {PRICE_TIERS.map(({ range, private: p, business: b }) => (
                    <tr key={range}>
                    <td style={tdStyle}>{range}</td>
                    <td style={tdStyleRight}>{p}</td>
                    <td style={tdStyle}>{range}</td>
                    <td style={tdStyleRight}>{b}</td>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>
        );
    }

    const LeftContentSection = () => (

        <LeftSection>
            <Heading>{localeMessages.howToCheck_title}</Heading>
            <SubText>{localeMessages.howToCheck_text}</SubText>

            <SubText style={{ display: 'flex' }}>
                {localeMessages.openTerms_text} <TextButton onClick={termsModal.showDialog}>her</TextButton>
            </SubText>
            <div style={{ display: 'flex', gap: '40px' }}>
                <SubText>{localeMessages.termsAgreedDate_text}: <b>{acceptedTermsDate}</b></SubText>
                <SubText>{localeMessages.termsAgreedSigned_text}: <b>{ratingData.billingEmail}</b></SubText>
            </div>
            <Heading>{localeMessages.deactivate_title}</Heading>
            {/* Forskjellig tekst avhengig av rollen til bruker */}
            {!isUserAdminOrHigher && (<SubText>{localeMessages.deactivate_text}</SubText>)}
            {isUserAdminOrHigher && (<SubText>{localeMessages.deactivateKreditor_text}</SubText>)}
            <DeactivateButton type="button" onClick={() => { setDeactivateValue(false); deactivateModal.showDialog();}}>
                {isUserAdminOrHigher ? localeMessages.deactivateUserButton : localeMessages.deactivateButton}
            </DeactivateButton>
            &nbsp;&nbsp;&nbsp;

            {/* Brukere med Role = User skal ikke se denne knappen */}
            {isUserAdminOrHigher && (<DeactivateButton type="button" onClick={() => { setDeactivateValue(true); deactivateModal.showDialog();}}>
                {localeMessages.deactivateKreditorButton}
            </DeactivateButton>)}
        </LeftSection>
    );

    const RightContentSection = () => (
        <RightSection>
            <Heading>{localeMessages.prislisteTitle}</Heading>
            <CreditEvaluationPriceList />
        </RightSection>
    );

    return (
        <>
        {termsModal.dialogVisible && <BislabTermsModal termsModal={termsModal} state={state} viewOnlyMode={true} />}
        {deactivateModal.dialogVisible && <DeactivateModal deactivateModal={deactivateModal} state={state} deactivateKreditor={deactivateValue}/>}

            <Container fluid="true">

                <KredittvurderingRowForm>
                    <SectionContainer>
                        <LeftContentSection />
                        <Divider />
                        <RightContentSection />
                    </SectionContainer>
                    &nbsp;&nbsp;
                </KredittvurderingRowForm>
            </Container>

        </>
    )
}
export default React.memo(InfoAndDeactivate)

